// Single source of truth for Firestore collection names.
// Per project convention, every top-level collection is prefixed `purplehearts_`.
// Subcollections (e.g. `sections` under a page) are namespaced by their prefixed
// parent, so they do not carry the prefix.
const PREFIX = "purplehearts_";

export const COL = {
  siteSettings: `${PREFIX}siteSettings`,
  pages: `${PREFIX}pages`,
  programs: `${PREFIX}programs`,
  events: `${PREFIX}events`,
  donorLeads: `${PREFIX}donorLeads`,
  donations: `${PREFIX}donations`,
  enquiries: `${PREFIX}enquiries`,
  blogPosts: `${PREFIX}blogPosts`,
  gallery: `${PREFIX}gallery`,
  schoolGroups: `${PREFIX}schoolGroups`,
  users: `${PREFIX}users`,
};

// Subcollection names (under a prefixed parent document).
export const SUB = {
  sections: "sections",
};

// Well-known single-document id for site-wide settings.
export const SETTINGS_DOC_ID = "main";

export { PREFIX };
